import { z } from 'zod/v3';

export const venuesSearchParamsSchema = z.object({
  create: z.boolean().optional(),
  edit: z.string().optional(),
  search: z.coerce.string().optional(),
  page: z.coerce.number().optional(),
  tabView: z.enum(['general', 'venue-area']).optional(),
});

export type VenuesSearchParamsSchemaType = z.infer<typeof venuesSearchParamsSchema>;
